import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { DataPilot } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${DataPilot.Pages.SMART_RADAR}`,
    name: DataPilot.Pages.DATA_PILOT,
    component: () => import(/* webpackChunkName: "data-pilot" */ './views/DataPilot.vue'),
    meta: {
      access_roles: RouteRoles[DataPilot.Pages.DATA_PILOT],
    },
  },
];

export default routes;
